export const ADD_FEED_BACK = 'ADD_FEED_BACK';
export const ADD_FEED_BACK_SUCCESS = 'ADD_FEED_BACK_SUCCESS';
export const ADD_FEED_BACK_FAILED = 'ADD_FEED_BACK_FAILED';
